import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LegacyExportService } from '@directives/_veri/export/legacyExport.service';
import { VExportButtonComponent } from '@directives/_veri/export/v-export-button/v-export-button.component';
import { VListComponent } from '@directives/_veri/v-list/v-list.component';
import { VTimelineComponent } from '@directives/_veri/v-timeline/v-timeline.component';
import { VeriNavPillsComponent } from '@directives/_veri/veriPills/veriPills.component';
import { providerCreator } from '@services/_services.module';
import { PipesModule } from 'src/app/_pipes/_pipes.module';
//import { NgxDynamicCompilerComponent } from '../_map/dynamicThing.component';
import { MiscDirectivesModule } from '../_misc/_misc.directives.module';
import { VVehicleVideoStreamComponent } from '../_vehicle/VehicleVideoStream/v-vehicle-video-stream.component';
import { DashboardBoxSmallComponent } from './dashboard/dashboardBoxSmall.component';
import { VCalendarComponent } from "./v-calendar/v-calendar.component";
import { VDateSelectorComponent } from "./v-date-selector/v-date-selector.component";
import { VDescriptiveListItemComponent } from './v-descriptive-list-item/v-descriptive-list-item.component';
import { VPillsComponent } from './v-pills/v-pills.component';
import { TagSelectorComponent } from './v-tags/tag-selector/tag-selector.component';
import { VTagsComponent } from './v-tags/v-tags.component';
import { VTimeFiltersComponent } from './v-time-filters/v-time-filters.component';
import { VeriBadgeComponent } from './veriBadge/veriBadge.component';
import { VeriCardComponent } from './veriCard/veriCard.component';
import { VeriColourPickerComponent } from './veriColourPicker/veriColourPicker.component';
import { VeriInfoPanelComponent } from './veriInfoPanel/veriInfoPanel.component';
import { VeriNumberFieldComponent } from './veriNumberField/veriNumberField.component';
import { VeriSearchBoxComponent } from './veriSearchBox/veriSearchBox.directive';
import { VeriSimpleNavComponent } from './veriSimpleNav/veriSimpleNav.component';
import { VeriTableContainerComponent } from './veriTable/veriTableContainer/veriTableContainer.component';
import { VeriTableSummaryComponent } from './veriTable/veriTableSummary/veriTableSummary.component';
import { VVideoComponent } from './veriVideo/v-video.component';
import { VVideoCollectionComponent } from './veriVideo/v-video-collection/v-video-collection.component';
import { VVideoControlsComponent } from './veriVideo/videoControls/video-controls.component';
import { VVideoProgressComponent } from './veriVideo/videoProgress/video-progress.component';
import { VeriVideoThumbnailsComponent } from './veriVideoThumbnails/veriVideoThumbnails.component';
import { VStreamCollectionComponent } from './veriVideo/v-stream-collection/v-stream-collection.component';
import { VDatePickerComponent } from "./v-date-picker/v-date-picker.component";

const privateComponents: Type<any>[] = [
];

const publicComponents: Type<any>[] = [
    DashboardBoxSmallComponent,
    VTagsComponent,
    VPillsComponent,
    VeriInfoPanelComponent,
    VeriNavPillsComponent,
    VeriCardComponent,
    VeriTableContainerComponent,
    VeriTableSummaryComponent,
    VeriBadgeComponent,
    VeriSearchBoxComponent,
    VeriSimpleNavComponent,
    VeriColourPickerComponent,
    VeriVideoThumbnailsComponent,
    VVideoComponent,
    VeriNumberFieldComponent,
    VExportButtonComponent,
    VeriNumberFieldComponent,
    VCalendarComponent,
    VDateSelectorComponent,
    VTimeFiltersComponent,
    VeriNumberFieldComponent,
    VTimelineComponent,
    VListComponent,
    VDescriptiveListItemComponent,
    VVideoControlsComponent,
    VVideoProgressComponent,
    VVideoCollectionComponent,
    VStreamCollectionComponent,
    VVehicleVideoStreamComponent,
    TagSelectorComponent,
    VDatePickerComponent
    //NgxDynamicCompilerComponent
];

@NgModule({
    providers: [
        providerCreator(LegacyExportService, "exportService"),
    ],
    imports: [
        CommonModule,
        FormsModule,
        MiscDirectivesModule,
        PipesModule,
        FormsDirectivesModule,
        CoreDirectivesModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents],
    exports: [...publicComponents],
    schemas: [NO_ERRORS_SCHEMA] // need this to allow highcharts angularjs component to work
    //schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VeriDirectivesModule {
    constructor() {
    }
}
